<template>
	<modal name="session-settings" :width="300" :height="400" @before-open="beforeOpen">
		<div id="session-settings-modal">
			<h1>{{ $t('session.title') }}</h1>
			<IconTimes class="close-modal" @click.native="$modal.hide('session-settings')" />
			<p><strong>{{ $t('session.claim') }}</strong></p>
			<div v-if="session === null">
				<p>{{ $t('session.helper') }}</p>
				<label>{{ $t('session.nameLabel') }}:</label>
				<input ref="createSessionInput" type="text" name="create-session-input" :placeholder="$t('session.namePlaceholder')" v-model="sessionName" autocomplete="off">
				<button type="button" class="create-session-button" @click="createSession">{{ $t('session.createButton') }}</button>
			</div>
			<div v-else>
				<div class="session-link">
					https://app.{{ $t('global.domain') }}/#/session/{{ sessionName }}
				</div>
				<button type="button" class="share-session-button" @click="shareSession"><IconShare /> {{ $t('session.shareButton') }}</button>
				<br><br><br>
				<button type="button" class="remove-session-button" @click="removeSession">{{ $t('session.cancelButton') }}</button>
			</div>
		</div>
	</modal>
</template>

<script>
	import { mapState } from "vuex";
	import IconTimes from "@/components/icons/IconTimes";
	import {SessionService} from "@/services/SessionService";
	import IconShare from "@/components/icons/IconShare";
	import { Share } from "@capacitor/share";

	export default {
		data() {
			return {
				sessionName: ""
			}
		},
		components: {
			IconShare,
			IconTimes
		},
		computed: {
			...mapState([ "currentUser", "session" ])
		},
		methods: {
			beforeOpen() {
				if (this.session !== null) {
					this.sessionName = this.session.name;
				} else {
					this.sessionName = this.currentUser.email.substring(0, this.currentUser.email.lastIndexOf("@"));
					// TODO: Odstranit specialni znaky
				}
			},
			createSession() {
				this.sessionName = this.sessionName.replace(/[^a-zA-Z]/g, "").toLowerCase();
				SessionService.createSession(this.sessionName);
				this.shareSession();
			},
			removeSession() {
				SessionService.removeSession();
			},
			shareSession() {
				Share.share({
					title: this.$t('session.share.title'),
					text: this.$t('session.share.text'),
					url: "https://app." + this.$t('global.domain') + "/#/session/" + this.sessionName,
					dialogTitle: this.$t('session.share.dialogTitle')
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	#session-settings-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;

		.close-modal {
			fill: white;
			width: 20px;
			opacity: 0.5;
			position: absolute;
			top: 20px;
			right: 20px;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		label {
			margin: 0 20px 0 20px;
			padding: 0;
			font-weight: 500;
		}

		input {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background-color: rgba(255, 255, 255, 0.21);
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 10px 0 0 0;

			&::placeholder {
				color: rgba(255, 255, 255, 0.49);
			}

			&:focus {
				outline: none;
			}
		}

		div.session-link {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background-color: rgba(255, 255, 255, 0.21);
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 10px 0 0 0;
			font-size: 0.7em;

			-webkit-user-select: all;
			-moz-user-select: all;
			-ms-user-select: all;
			user-select: all;
		}

		button.create-session-button, button.share-session-button {
			font-weight: 100;
			margin: 11px 20px 0 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #ef904e;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #d07a46;
			}

			&:focus {
				outline: none;
			}

			.icon-share {
				width: 21px;
				float: left;
				margin: 3px 0 -3px 0;
			}
		}

		button.remove-session-button {
			opacity: 0.7;
			font-weight: 100;
			margin: 5px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				opacity: 1;
				background-color: #2f4f5f;
			}

			&:focus {
				outline: none;
			}
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;

			a {
				color: rgb(233,196,106);
				text-decoration: underline;

				&:hover {
					color: rgb(211, 177, 97);
				}
			}
		}
	}
</style>
